import { ENVIRONMENTCP, EnvironmentCp } from '@v2/environment/environment-cp';
import { provideDiTokenValue } from '@v2/utilities/di/di-token';
import { provideSingleton } from '@v2/utilities/di/provide-singleton';
import { HttpClient, provideHttpClient } from '../http-client';
import { CpBpApiConfig, provideCpBpApiConfig } from './cp-bp-api-config';

export class CpApi {
  constructor(
    private _environmentCp: EnvironmentCp,
    public apiConfig: CpBpApiConfig,
    public http: HttpClient
  ) {}

  private _urlReplaced(url: string): string {
    return url
      .replace('{apiVersion}', this._environmentCp.apiVersion)
      .replace('{env}', this._environmentCp.envName ?? '');
  }

  private get _userApiUrlReplaced(): string {
    return this._urlReplaced(this._environmentCp.userApiUrl);
  }

  private get _walletApiUrlReplaced(): string {
    return this._urlReplaced(this._environmentCp.walletApiUrl);
  }

  private get _paymentApiUrlReplaced(): string {
    return this._urlReplaced(this._environmentCp.paymentApiUrl);
  }

  public get userBaseApiUrl(): string {
    return this._userApiUrlReplaced;
  }

  public get userApiUrl(): string {
    return `${this._userApiUrlReplaced}user/`;
  }

  public get inboxApiUrl(): string {
    return `${this._userApiUrlReplaced}inbox/`;
  }

  public get walletApiUserUrl(): string {
    return `${this._walletApiUrlReplaced}api/user/`;
  }

  public get walletApiUrl(): string {
    return `${this._walletApiUrlReplaced}api/`;
  }

  public get walletApiFreespinsUrl(): string {
    return `${this._walletApiUrlReplaced}freespins/`;
  }

  public get walletApiGamesUrl(): string {
    return `${this._walletApiUrlReplaced}games/`;
  }

  public get paymentBaseApiUrl(): string {
    return this._paymentApiUrlReplaced;
  }
}

export function provideCpApi(): CpApi {
  return provideSingleton(
    CpApi,
    () => new CpApi(provideDiTokenValue(ENVIRONMENTCP), provideCpBpApiConfig(), provideHttpClient())
  );
}
